import React, { Component } from "react";
import { navigateToAuthenticatedDownload } from "../../../utils/downloadUtils";
import Loader from "../../common/loader/Loader";

class DocumentDownload extends Component {
  state = {
    status: "loading",
    message: "",
  };

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const uri = params.get("uri");

    if (!uri) {
      this.setState({ status: "error", message: "Missing document uri." });
      return;
    }

    try {
      await navigateToAuthenticatedDownload(
        `/api/files/download/binary${window.location.search}`,
      );
    } catch (error) {
      const status = error?.response?.status;
      this.setState({
        status: "error",
        message:
          status === 404
            ? "Document not found."
            : "Could not download the document.",
      });
    }
  }

  render() {
    const { status, message } = this.state;
    const portalUrl = process.env.REACT_APP_BASE_URL || "/";

    const wrapperStyle = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      gap: 16,
      padding: 24,
      textAlign: "center",
    };

    if (status === "loading") {
      return (
        <div style={wrapperStyle}>
          <Loader />
          <p>Preparing your document…</p>
        </div>
      );
    }

    return (
      <div style={wrapperStyle}>
        <p>{message}</p>
        <a href={portalUrl}>Back to the portal</a>
      </div>
    );
  }
}

export default DocumentDownload;
